/**
 * "Resolver" de um atendimento do card "Convênios a conferir": avisos com ação,
 * mensagem pronta para a pessoa e os documentos vinculados (vincular, criar,
 * desvincular), tudo sem sair do Início. Os avisos vêm do próprio card, que
 * recarrega a cada mudança; "Abrir na agenda" fica como atalho secundário.
 */
import React from 'react';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import PopupBase from '../../../../popup/base/PopupBase';
import InsuranceAlertList from '../../../appointments/v2/components/InsuranceAlerts/InsuranceAlertList';
import AskPersonButton from '../../../appointments/v2/components/InsuranceAlerts/AskPersonButton';
import AppointmentInsuranceDocuments from '../../../appointments/v2/components/AppointmentDetailPanel/AppointmentInsuranceDocuments';
import { dayLabel, timeLabel } from './pendingFormat';
import styles from './InsurancePending.module.css';

function InsurancePendingResolvePopup({
  item, alertAction, pickerToken, refreshToken, onChanged, onOpenSchedule, onClose,
}) {
  const coverage = [item.provider_name, item.plan_name, item.resource_name].filter(Boolean).join(' · ');

  const content = (
    <div className={styles.resolve}>
      <p className={styles.resolveWhen}>
        {dayLabel(item.date)} às {timeLabel(item.date)}
        {coverage && <span className={styles.resolveCoverage}>{coverage}</span>}
      </p>

      {item.alerts.length > 0 ? (
        <InsuranceAlertList alerts={item.alerts} alertAction={alertAction} />
      ) : (
        <p className={styles.allGood}>Tudo certo com este atendimento.</p>
      )}

      <div className={styles.resolveActions}>
        <AskPersonButton
          alerts={item.alerts}
          patientId={item.patient_id}
          date={item.date}
          providerName={item.provider_name}
        />
      </div>

      <AppointmentInsuranceDocuments
        appointment={{
          id: item.id,
          patient: item.patient_id,
          patient_insurance_id: item.patient_insurance_id,
          insurance_provider_id: item.provider_id,
          date: item.date,
        }}
        onChanged={onChanged}
        refreshToken={refreshToken}
        openPickerToken={pickerToken}
      />

      <button type="button" className={styles.scheduleLink} onClick={onOpenSchedule}>
        <EventOutlinedIcon sx={{ fontSize: 16 }} /> Abrir na agenda
      </button>
    </div>
  );

  return (
    <PopupBase
      Title={item.patient_name || 'Sem nome'}
      Content={content}
      OnClose={onClose}
      maxWidth="sm"
    />
  );
}

export default InsurancePendingResolvePopup;
